// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animate-circle {
  animation: circle-home 10s linear 0s infinite;
}
@keyframes circle-home {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.animate-fade-out {
  animation: fade-phone 2s forwards;
}
@keyframes fade-phone {
  0% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
.loading-btns {
  padding: 10px;
  animation: spin 0.4s linear 0s infinite;
  display: inline-block;
  border-radius: 50%;
  border-left: 3.5px dotted #3d0400;
  width: 10px !important;
  height: 10px !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.loading-page {
  padding: 30px;
  animation: loading-page 0.4s linear 0s infinite;
  display: inline-block;
  border-radius: 50%;
  border-left: 4.5px dotted #e1b964;
}

@keyframes loading-page {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.layout-gradiant .stars {
  animation: stars 150s linear 0s infinite;
}
.layout-gradiant .stars-plus {
  animation: stars 5s linear 0s infinite;
}
@keyframes stars {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
#winner-loading {
  padding: 13px;
  animation: spin 0.4s linear 0s infinite;
  display: inline-block;
  border-radius: 50%;
  border-left: 3.5px solid #0fc2a9;
}

.scale-bg {
  animation: scale-bg 1s forwards;
}
@keyframes scale-bg {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.animate-box-result {
  animation: ani-result 1s forwards;
}
@keyframes ani-result {
  0% {
    top: -224px;
    opacity: 0;
  }
  100% {
    top: -3px;
    opacity: 1;
  }
}
.animate-controller {
  animation: animate-controller 2s forwards;
}
@keyframes animate-controller {
  0% {
    transform: rotateY(90deg);
  }
  100% {
    transform: rotateX(0deg);
  }
}

.ani-open-modal {
  animation: modal-show 1s forwards;
}
@keyframes modal-show {
  0% {
    transform: translateY(-55vh);
  }
  50% {
    transform: translateY(4vh);
  }
  100% {
    transform: translateY(0vh);
  }
}
.ani-close-modal {
  animation: modal-hide 1s forwards;
}
@keyframes modal-hide {
  0% {
    transform: translateY(0vh);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(74vh);
  }
}
@media screen and (min-width: 1200px) {
  .scale-bg {
    animation: scale-bg 1s forwards;
  }
  @keyframes scale-bg {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(3.5);
    }
  }
  .animate-box-result {
    animation: ani-result 1s forwards;
  }
  @keyframes ani-result {
    0% {
      top: -338px;
      opacity: 0;
    }
    100% {
      top: -5px;
      opacity: 1;
    }
  }
}
#icon-show-score {
  animation-name: show-score;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  position: relative;
  width: 20px;
  margin-right: 8px;
}
@keyframes show-score {
  0% {
    top: 5px;
  }
  100% {
    top: -5px;
  }
}
.wheel-lazy-loading {
  background-image: linear-gradient(
    to right,
    #1ac977 0%,
    #0aa15b 10%,
    #1ac977 20%,
    #1ac977 100%
  );
  background-size: 200% 100%;
  animation: bgPos 1s linear infinite;
}
@keyframes bgPos {
  0% {
    background-position: 50% 0;
  }

  100% {
    background-position: -150% 0;
  }
}

.ani-fade {
  animation: ani-fade 2s forwards;
}
@keyframes ani-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.result-overlay {
  position: absolute;
  top: 23px;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  z-index: 100;
  opacity: 0.1;
}
.ani-fade-loading {
  animation: fade-loading 1s linear 0s infinite;
}
@keyframes fade-loading {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.ani-fade-option-select {
  animation: option-select 1s linear 0s infinite;
}
@keyframes option-select {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.fade-in {
  animation: fade-in 800ms forwards;
}
.fade-in-1 {
  animation: fade-in 2s forwards;
}
@keyframes fade-in {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
.slide-left {
  animation: slide-left 300ms forwards;
}
@keyframes slide-left {
  0% {
    transform: translateX(-90px);
  }
  100% {
    transform: translateX(0px);
  }
}
.slide-right {
  animation: slide-right 300ms forwards;
}
@keyframes slide-right {
  0% {
    transform: translateX(+90px);
  }
  100% {
    transform: translateX(0);
  }
}
.slide-bottom {
  animation: slide-bottom 500ms forwards;
}
@keyframes slide-bottom {
  0% {
    transform: translateY(+90px);
  }
  100% {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/animations.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;EACF;EACA;IACE,iCAAiC;EACnC;EACA;IACE;MACE,WAAW;MACX,UAAU;IACZ;IACA;MACE,SAAS;MACT,UAAU;IACZ;EACF;AACF;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;;;;;;GAMC;EACD,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,YAAY;EAEZ,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,8CAA8C;AAChD;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".animate-circle {\n  animation: circle-home 10s linear 0s infinite;\n}\n@keyframes circle-home {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.animate-fade-out {\n  animation: fade-phone 2s forwards;\n}\n@keyframes fade-phone {\n  0% {\n    opacity: 0.1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.loading-btns {\n  padding: 10px;\n  animation: spin 0.4s linear 0s infinite;\n  display: inline-block;\n  border-radius: 50%;\n  border-left: 3.5px dotted #3d0400;\n  width: 10px !important;\n  height: 10px !important;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loading-page {\n  padding: 30px;\n  animation: loading-page 0.4s linear 0s infinite;\n  display: inline-block;\n  border-radius: 50%;\n  border-left: 4.5px dotted #e1b964;\n}\n\n@keyframes loading-page {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.layout-gradiant .stars {\n  animation: stars 150s linear 0s infinite;\n}\n.layout-gradiant .stars-plus {\n  animation: stars 5s linear 0s infinite;\n}\n@keyframes stars {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n#winner-loading {\n  padding: 13px;\n  animation: spin 0.4s linear 0s infinite;\n  display: inline-block;\n  border-radius: 50%;\n  border-left: 3.5px solid #0fc2a9;\n}\n\n.scale-bg {\n  animation: scale-bg 1s forwards;\n}\n@keyframes scale-bg {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n}\n.animate-box-result {\n  animation: ani-result 1s forwards;\n}\n@keyframes ani-result {\n  0% {\n    top: -224px;\n    opacity: 0;\n  }\n  100% {\n    top: -3px;\n    opacity: 1;\n  }\n}\n.animate-controller {\n  animation: animate-controller 2s forwards;\n}\n@keyframes animate-controller {\n  0% {\n    transform: rotateY(90deg);\n  }\n  100% {\n    transform: rotateX(0deg);\n  }\n}\n\n.ani-open-modal {\n  animation: modal-show 1s forwards;\n}\n@keyframes modal-show {\n  0% {\n    transform: translateY(-55vh);\n  }\n  50% {\n    transform: translateY(4vh);\n  }\n  100% {\n    transform: translateY(0vh);\n  }\n}\n.ani-close-modal {\n  animation: modal-hide 1s forwards;\n}\n@keyframes modal-hide {\n  0% {\n    transform: translateY(0vh);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(74vh);\n  }\n}\n@media screen and (min-width: 1200px) {\n  .scale-bg {\n    animation: scale-bg 1s forwards;\n  }\n  @keyframes scale-bg {\n    0% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(3.5);\n    }\n  }\n  .animate-box-result {\n    animation: ani-result 1s forwards;\n  }\n  @keyframes ani-result {\n    0% {\n      top: -338px;\n      opacity: 0;\n    }\n    100% {\n      top: -5px;\n      opacity: 1;\n    }\n  }\n}\n#icon-show-score {\n  animation-name: show-score;\n  animation-duration: 1s;\n  animation-direction: alternate;\n  animation-iteration-count: infinite;\n  position: relative;\n  width: 20px;\n  margin-right: 8px;\n}\n@keyframes show-score {\n  0% {\n    top: 5px;\n  }\n  100% {\n    top: -5px;\n  }\n}\n.wheel-lazy-loading {\n  background-image: linear-gradient(\n    to right,\n    #1ac977 0%,\n    #0aa15b 10%,\n    #1ac977 20%,\n    #1ac977 100%\n  );\n  background-size: 200% 100%;\n  animation: bgPos 1s linear infinite;\n}\n@keyframes bgPos {\n  0% {\n    background-position: 50% 0;\n  }\n\n  100% {\n    background-position: -150% 0;\n  }\n}\n\n.ani-fade {\n  animation: ani-fade 2s forwards;\n}\n@keyframes ani-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.result-overlay {\n  position: absolute;\n  top: 23px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: black;\n  z-index: 100;\n  opacity: 0.2;\n  opacity: 0.1;\n}\n.ani-fade-loading {\n  animation: fade-loading 1s linear 0s infinite;\n}\n@keyframes fade-loading {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ani-fade-option-select {\n  animation: option-select 1s linear 0s infinite;\n}\n@keyframes option-select {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fade-in {\n  animation: fade-in 800ms forwards;\n}\n.fade-in-1 {\n  animation: fade-in 2s forwards;\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n    visibility: hidden;\n  }\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n.slide-left {\n  animation: slide-left 300ms forwards;\n}\n@keyframes slide-left {\n  0% {\n    transform: translateX(-90px);\n  }\n  100% {\n    transform: translateX(0px);\n  }\n}\n.slide-right {\n  animation: slide-right 300ms forwards;\n}\n@keyframes slide-right {\n  0% {\n    transform: translateX(+90px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.slide-bottom {\n  animation: slide-bottom 500ms forwards;\n}\n@keyframes slide-bottom {\n  0% {\n    transform: translateY(+90px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
